__turbopack_context__.v({
  "body-20": "type-styles-module-scss-module__YGKmvq__body-20",
  "body-20--lg": "type-styles-module-scss-module__YGKmvq__body-20--lg",
  "body-20--md": "type-styles-module-scss-module__YGKmvq__body-20--md",
  "body-20--sm": "type-styles-module-scss-module__YGKmvq__body-20--sm",
  "body-20--tablet": "type-styles-module-scss-module__YGKmvq__body-20--tablet",
  "body-20--xl": "type-styles-module-scss-module__YGKmvq__body-20--xl",
  "body-20--xs": "type-styles-module-scss-module__YGKmvq__body-20--xs",
  "body-20--xxs": "type-styles-module-scss-module__YGKmvq__body-20--xxs",
  "body-2xl": "type-styles-module-scss-module__YGKmvq__body-2xl",
  "body-2xl--lg": "type-styles-module-scss-module__YGKmvq__body-2xl--lg",
  "body-2xl--md": "type-styles-module-scss-module__YGKmvq__body-2xl--md",
  "body-2xl--sm": "type-styles-module-scss-module__YGKmvq__body-2xl--sm",
  "body-2xl--tablet": "type-styles-module-scss-module__YGKmvq__body-2xl--tablet",
  "body-2xl--xl": "type-styles-module-scss-module__YGKmvq__body-2xl--xl",
  "body-2xl--xs": "type-styles-module-scss-module__YGKmvq__body-2xl--xs",
  "body-2xl--xxs": "type-styles-module-scss-module__YGKmvq__body-2xl--xxs",
  "body-2xs": "type-styles-module-scss-module__YGKmvq__body-2xs",
  "body-2xs--lg": "type-styles-module-scss-module__YGKmvq__body-2xs--lg",
  "body-2xs--md": "type-styles-module-scss-module__YGKmvq__body-2xs--md",
  "body-2xs--sm": "type-styles-module-scss-module__YGKmvq__body-2xs--sm",
  "body-2xs--tablet": "type-styles-module-scss-module__YGKmvq__body-2xs--tablet",
  "body-2xs--xl": "type-styles-module-scss-module__YGKmvq__body-2xs--xl",
  "body-2xs--xs": "type-styles-module-scss-module__YGKmvq__body-2xs--xs",
  "body-2xs--xxs": "type-styles-module-scss-module__YGKmvq__body-2xs--xxs",
  "body-3xl": "type-styles-module-scss-module__YGKmvq__body-3xl",
  "body-3xl--lg": "type-styles-module-scss-module__YGKmvq__body-3xl--lg",
  "body-3xl--md": "type-styles-module-scss-module__YGKmvq__body-3xl--md",
  "body-3xl--sm": "type-styles-module-scss-module__YGKmvq__body-3xl--sm",
  "body-3xl--tablet": "type-styles-module-scss-module__YGKmvq__body-3xl--tablet",
  "body-3xl--xl": "type-styles-module-scss-module__YGKmvq__body-3xl--xl",
  "body-3xl--xs": "type-styles-module-scss-module__YGKmvq__body-3xl--xs",
  "body-3xl--xxs": "type-styles-module-scss-module__YGKmvq__body-3xl--xxs",
  "body-3xs": "type-styles-module-scss-module__YGKmvq__body-3xs",
  "body-3xs--lg": "type-styles-module-scss-module__YGKmvq__body-3xs--lg",
  "body-3xs--md": "type-styles-module-scss-module__YGKmvq__body-3xs--md",
  "body-3xs--sm": "type-styles-module-scss-module__YGKmvq__body-3xs--sm",
  "body-3xs--tablet": "type-styles-module-scss-module__YGKmvq__body-3xs--tablet",
  "body-3xs--xl": "type-styles-module-scss-module__YGKmvq__body-3xs--xl",
  "body-3xs--xs": "type-styles-module-scss-module__YGKmvq__body-3xs--xs",
  "body-3xs--xxs": "type-styles-module-scss-module__YGKmvq__body-3xs--xxs",
  "body-lg": "type-styles-module-scss-module__YGKmvq__body-lg",
  "body-lg--lg": "type-styles-module-scss-module__YGKmvq__body-lg--lg",
  "body-lg--md": "type-styles-module-scss-module__YGKmvq__body-lg--md",
  "body-lg--sm": "type-styles-module-scss-module__YGKmvq__body-lg--sm",
  "body-lg--tablet": "type-styles-module-scss-module__YGKmvq__body-lg--tablet",
  "body-lg--xl": "type-styles-module-scss-module__YGKmvq__body-lg--xl",
  "body-lg--xs": "type-styles-module-scss-module__YGKmvq__body-lg--xs",
  "body-lg--xxs": "type-styles-module-scss-module__YGKmvq__body-lg--xxs",
  "body-md": "type-styles-module-scss-module__YGKmvq__body-md",
  "body-md--lg": "type-styles-module-scss-module__YGKmvq__body-md--lg",
  "body-md--md": "type-styles-module-scss-module__YGKmvq__body-md--md",
  "body-md--sm": "type-styles-module-scss-module__YGKmvq__body-md--sm",
  "body-md--tablet": "type-styles-module-scss-module__YGKmvq__body-md--tablet",
  "body-md--xl": "type-styles-module-scss-module__YGKmvq__body-md--xl",
  "body-md--xs": "type-styles-module-scss-module__YGKmvq__body-md--xs",
  "body-md--xxs": "type-styles-module-scss-module__YGKmvq__body-md--xxs",
  "body-xl": "type-styles-module-scss-module__YGKmvq__body-xl",
  "body-xl--lg": "type-styles-module-scss-module__YGKmvq__body-xl--lg",
  "body-xl--md": "type-styles-module-scss-module__YGKmvq__body-xl--md",
  "body-xl--sm": "type-styles-module-scss-module__YGKmvq__body-xl--sm",
  "body-xl--tablet": "type-styles-module-scss-module__YGKmvq__body-xl--tablet",
  "body-xl--xl": "type-styles-module-scss-module__YGKmvq__body-xl--xl",
  "body-xl--xs": "type-styles-module-scss-module__YGKmvq__body-xl--xs",
  "body-xl--xxs": "type-styles-module-scss-module__YGKmvq__body-xl--xxs",
  "body-xs": "type-styles-module-scss-module__YGKmvq__body-xs",
  "body-xs--lg": "type-styles-module-scss-module__YGKmvq__body-xs--lg",
  "body-xs--md": "type-styles-module-scss-module__YGKmvq__body-xs--md",
  "body-xs--sm": "type-styles-module-scss-module__YGKmvq__body-xs--sm",
  "body-xs--tablet": "type-styles-module-scss-module__YGKmvq__body-xs--tablet",
  "body-xs--xl": "type-styles-module-scss-module__YGKmvq__body-xs--xl",
  "body-xs--xs": "type-styles-module-scss-module__YGKmvq__body-xs--xs",
  "body-xs--xxs": "type-styles-module-scss-module__YGKmvq__body-xs--xxs",
  "heading-120": "type-styles-module-scss-module__YGKmvq__heading-120",
  "heading-120--lg": "type-styles-module-scss-module__YGKmvq__heading-120--lg",
  "heading-120--md": "type-styles-module-scss-module__YGKmvq__heading-120--md",
  "heading-120--sm": "type-styles-module-scss-module__YGKmvq__heading-120--sm",
  "heading-120--tablet": "type-styles-module-scss-module__YGKmvq__heading-120--tablet",
  "heading-120--xl": "type-styles-module-scss-module__YGKmvq__heading-120--xl",
  "heading-120--xs": "type-styles-module-scss-module__YGKmvq__heading-120--xs",
  "heading-120--xxs": "type-styles-module-scss-module__YGKmvq__heading-120--xxs",
  "heading-128": "type-styles-module-scss-module__YGKmvq__heading-128",
  "heading-128--lg": "type-styles-module-scss-module__YGKmvq__heading-128--lg",
  "heading-128--md": "type-styles-module-scss-module__YGKmvq__heading-128--md",
  "heading-128--sm": "type-styles-module-scss-module__YGKmvq__heading-128--sm",
  "heading-128--tablet": "type-styles-module-scss-module__YGKmvq__heading-128--tablet",
  "heading-128--xl": "type-styles-module-scss-module__YGKmvq__heading-128--xl",
  "heading-128--xs": "type-styles-module-scss-module__YGKmvq__heading-128--xs",
  "heading-128--xxs": "type-styles-module-scss-module__YGKmvq__heading-128--xxs",
  "heading-150": "type-styles-module-scss-module__YGKmvq__heading-150",
  "heading-150--lg": "type-styles-module-scss-module__YGKmvq__heading-150--lg",
  "heading-150--md": "type-styles-module-scss-module__YGKmvq__heading-150--md",
  "heading-150--sm": "type-styles-module-scss-module__YGKmvq__heading-150--sm",
  "heading-150--tablet": "type-styles-module-scss-module__YGKmvq__heading-150--tablet",
  "heading-150--xl": "type-styles-module-scss-module__YGKmvq__heading-150--xl",
  "heading-150--xs": "type-styles-module-scss-module__YGKmvq__heading-150--xs",
  "heading-150--xxs": "type-styles-module-scss-module__YGKmvq__heading-150--xxs",
  "heading-2xl": "type-styles-module-scss-module__YGKmvq__heading-2xl",
  "heading-2xl--lg": "type-styles-module-scss-module__YGKmvq__heading-2xl--lg",
  "heading-2xl--md": "type-styles-module-scss-module__YGKmvq__heading-2xl--md",
  "heading-2xl--sm": "type-styles-module-scss-module__YGKmvq__heading-2xl--sm",
  "heading-2xl--tablet": "type-styles-module-scss-module__YGKmvq__heading-2xl--tablet",
  "heading-2xl--xl": "type-styles-module-scss-module__YGKmvq__heading-2xl--xl",
  "heading-2xl--xs": "type-styles-module-scss-module__YGKmvq__heading-2xl--xs",
  "heading-2xl--xxs": "type-styles-module-scss-module__YGKmvq__heading-2xl--xxs",
  "heading-3xl": "type-styles-module-scss-module__YGKmvq__heading-3xl",
  "heading-3xl--lg": "type-styles-module-scss-module__YGKmvq__heading-3xl--lg",
  "heading-3xl--md": "type-styles-module-scss-module__YGKmvq__heading-3xl--md",
  "heading-3xl--sm": "type-styles-module-scss-module__YGKmvq__heading-3xl--sm",
  "heading-3xl--tablet": "type-styles-module-scss-module__YGKmvq__heading-3xl--tablet",
  "heading-3xl--xl": "type-styles-module-scss-module__YGKmvq__heading-3xl--xl",
  "heading-3xl--xs": "type-styles-module-scss-module__YGKmvq__heading-3xl--xs",
  "heading-3xl--xxs": "type-styles-module-scss-module__YGKmvq__heading-3xl--xxs",
  "heading-4xl": "type-styles-module-scss-module__YGKmvq__heading-4xl",
  "heading-4xl--lg": "type-styles-module-scss-module__YGKmvq__heading-4xl--lg",
  "heading-4xl--md": "type-styles-module-scss-module__YGKmvq__heading-4xl--md",
  "heading-4xl--sm": "type-styles-module-scss-module__YGKmvq__heading-4xl--sm",
  "heading-4xl--tablet": "type-styles-module-scss-module__YGKmvq__heading-4xl--tablet",
  "heading-4xl--xl": "type-styles-module-scss-module__YGKmvq__heading-4xl--xl",
  "heading-4xl--xs": "type-styles-module-scss-module__YGKmvq__heading-4xl--xs",
  "heading-4xl--xxs": "type-styles-module-scss-module__YGKmvq__heading-4xl--xxs",
  "heading-5xl": "type-styles-module-scss-module__YGKmvq__heading-5xl",
  "heading-5xl--lg": "type-styles-module-scss-module__YGKmvq__heading-5xl--lg",
  "heading-5xl--md": "type-styles-module-scss-module__YGKmvq__heading-5xl--md",
  "heading-5xl--sm": "type-styles-module-scss-module__YGKmvq__heading-5xl--sm",
  "heading-5xl--tablet": "type-styles-module-scss-module__YGKmvq__heading-5xl--tablet",
  "heading-5xl--xl": "type-styles-module-scss-module__YGKmvq__heading-5xl--xl",
  "heading-5xl--xs": "type-styles-module-scss-module__YGKmvq__heading-5xl--xs",
  "heading-5xl--xxs": "type-styles-module-scss-module__YGKmvq__heading-5xl--xxs",
  "heading-60": "type-styles-module-scss-module__YGKmvq__heading-60",
  "heading-60--lg": "type-styles-module-scss-module__YGKmvq__heading-60--lg",
  "heading-60--md": "type-styles-module-scss-module__YGKmvq__heading-60--md",
  "heading-60--sm": "type-styles-module-scss-module__YGKmvq__heading-60--sm",
  "heading-60--tablet": "type-styles-module-scss-module__YGKmvq__heading-60--tablet",
  "heading-60--xl": "type-styles-module-scss-module__YGKmvq__heading-60--xl",
  "heading-60--xs": "type-styles-module-scss-module__YGKmvq__heading-60--xs",
  "heading-60--xxs": "type-styles-module-scss-module__YGKmvq__heading-60--xxs",
  "heading-70": "type-styles-module-scss-module__YGKmvq__heading-70",
  "heading-70--lg": "type-styles-module-scss-module__YGKmvq__heading-70--lg",
  "heading-70--md": "type-styles-module-scss-module__YGKmvq__heading-70--md",
  "heading-70--sm": "type-styles-module-scss-module__YGKmvq__heading-70--sm",
  "heading-70--tablet": "type-styles-module-scss-module__YGKmvq__heading-70--tablet",
  "heading-70--xl": "type-styles-module-scss-module__YGKmvq__heading-70--xl",
  "heading-70--xs": "type-styles-module-scss-module__YGKmvq__heading-70--xs",
  "heading-70--xxs": "type-styles-module-scss-module__YGKmvq__heading-70--xxs",
  "heading-90": "type-styles-module-scss-module__YGKmvq__heading-90",
  "heading-90--lg": "type-styles-module-scss-module__YGKmvq__heading-90--lg",
  "heading-90--md": "type-styles-module-scss-module__YGKmvq__heading-90--md",
  "heading-90--sm": "type-styles-module-scss-module__YGKmvq__heading-90--sm",
  "heading-90--tablet": "type-styles-module-scss-module__YGKmvq__heading-90--tablet",
  "heading-90--xl": "type-styles-module-scss-module__YGKmvq__heading-90--xl",
  "heading-90--xs": "type-styles-module-scss-module__YGKmvq__heading-90--xs",
  "heading-90--xxs": "type-styles-module-scss-module__YGKmvq__heading-90--xxs",
  "heading-lg": "type-styles-module-scss-module__YGKmvq__heading-lg",
  "heading-lg--lg": "type-styles-module-scss-module__YGKmvq__heading-lg--lg",
  "heading-lg--md": "type-styles-module-scss-module__YGKmvq__heading-lg--md",
  "heading-lg--sm": "type-styles-module-scss-module__YGKmvq__heading-lg--sm",
  "heading-lg--tablet": "type-styles-module-scss-module__YGKmvq__heading-lg--tablet",
  "heading-lg--xl": "type-styles-module-scss-module__YGKmvq__heading-lg--xl",
  "heading-lg--xs": "type-styles-module-scss-module__YGKmvq__heading-lg--xs",
  "heading-lg--xxs": "type-styles-module-scss-module__YGKmvq__heading-lg--xxs",
  "heading-md": "type-styles-module-scss-module__YGKmvq__heading-md",
  "heading-md--lg": "type-styles-module-scss-module__YGKmvq__heading-md--lg",
  "heading-md--md": "type-styles-module-scss-module__YGKmvq__heading-md--md",
  "heading-md--sm": "type-styles-module-scss-module__YGKmvq__heading-md--sm",
  "heading-md--tablet": "type-styles-module-scss-module__YGKmvq__heading-md--tablet",
  "heading-md--xl": "type-styles-module-scss-module__YGKmvq__heading-md--xl",
  "heading-md--xs": "type-styles-module-scss-module__YGKmvq__heading-md--xs",
  "heading-md--xxs": "type-styles-module-scss-module__YGKmvq__heading-md--xxs",
  "heading-sm": "type-styles-module-scss-module__YGKmvq__heading-sm",
  "heading-sm--lg": "type-styles-module-scss-module__YGKmvq__heading-sm--lg",
  "heading-sm--md": "type-styles-module-scss-module__YGKmvq__heading-sm--md",
  "heading-sm--sm": "type-styles-module-scss-module__YGKmvq__heading-sm--sm",
  "heading-sm--tablet": "type-styles-module-scss-module__YGKmvq__heading-sm--tablet",
  "heading-sm--xl": "type-styles-module-scss-module__YGKmvq__heading-sm--xl",
  "heading-sm--xs": "type-styles-module-scss-module__YGKmvq__heading-sm--xs",
  "heading-sm--xxs": "type-styles-module-scss-module__YGKmvq__heading-sm--xxs",
  "heading-xl": "type-styles-module-scss-module__YGKmvq__heading-xl",
  "heading-xl--lg": "type-styles-module-scss-module__YGKmvq__heading-xl--lg",
  "heading-xl--md": "type-styles-module-scss-module__YGKmvq__heading-xl--md",
  "heading-xl--sm": "type-styles-module-scss-module__YGKmvq__heading-xl--sm",
  "heading-xl--tablet": "type-styles-module-scss-module__YGKmvq__heading-xl--tablet",
  "heading-xl--xl": "type-styles-module-scss-module__YGKmvq__heading-xl--xl",
  "heading-xl--xs": "type-styles-module-scss-module__YGKmvq__heading-xl--xs",
  "heading-xl--xxs": "type-styles-module-scss-module__YGKmvq__heading-xl--xxs",
  "heading-xs": "type-styles-module-scss-module__YGKmvq__heading-xs",
  "heading-xs--lg": "type-styles-module-scss-module__YGKmvq__heading-xs--lg",
  "heading-xs--md": "type-styles-module-scss-module__YGKmvq__heading-xs--md",
  "heading-xs--sm": "type-styles-module-scss-module__YGKmvq__heading-xs--sm",
  "heading-xs--tablet": "type-styles-module-scss-module__YGKmvq__heading-xs--tablet",
  "heading-xs--xl": "type-styles-module-scss-module__YGKmvq__heading-xs--xl",
  "heading-xs--xs": "type-styles-module-scss-module__YGKmvq__heading-xs--xs",
  "heading-xs--xxs": "type-styles-module-scss-module__YGKmvq__heading-xs--xxs",
  "heading-xxs": "type-styles-module-scss-module__YGKmvq__heading-xxs",
  "heading-xxs--lg": "type-styles-module-scss-module__YGKmvq__heading-xxs--lg",
  "heading-xxs--md": "type-styles-module-scss-module__YGKmvq__heading-xxs--md",
  "heading-xxs--sm": "type-styles-module-scss-module__YGKmvq__heading-xxs--sm",
  "heading-xxs--tablet": "type-styles-module-scss-module__YGKmvq__heading-xxs--tablet",
  "heading-xxs--xl": "type-styles-module-scss-module__YGKmvq__heading-xxs--xl",
  "heading-xxs--xs": "type-styles-module-scss-module__YGKmvq__heading-xxs--xs",
  "heading-xxs--xxs": "type-styles-module-scss-module__YGKmvq__heading-xxs--xxs",
  "large-prompt": "type-styles-module-scss-module__YGKmvq__large-prompt",
  "large-prompt--lg": "type-styles-module-scss-module__YGKmvq__large-prompt--lg",
  "large-prompt--md": "type-styles-module-scss-module__YGKmvq__large-prompt--md",
  "large-prompt--sm": "type-styles-module-scss-module__YGKmvq__large-prompt--sm",
  "large-prompt--tablet": "type-styles-module-scss-module__YGKmvq__large-prompt--tablet",
  "large-prompt--xl": "type-styles-module-scss-module__YGKmvq__large-prompt--xl",
  "large-prompt--xs": "type-styles-module-scss-module__YGKmvq__large-prompt--xs",
  "large-prompt--xxs": "type-styles-module-scss-module__YGKmvq__large-prompt--xxs",
});
